var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.boxClass },
    [
      _c(
        "a-pagination",
        _vm._b(
          {
            attrs: { disabled: _vm.disabled },
            on: {
              change: _vm.handleChange,
              showSizeChange: _vm.handleShowSizeChange,
            },
          },
          "a-pagination",
          _vm.bindProps,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }